<template>
  <div class="order-item" @click="goDetailsHandler">
    <div class="lft">
      <div class="lottery">{{ props.item.lotteryName }}</div>
      <div class="meta">
        <span class="sn">#{{ props.item.orderSn.substring(9, 15) }}</span>
        <span class="dot">·</span>
        <span class="time">{{ $filters.formatDate(props.item.createdAt) }}</span>
      </div>
    </div>
    <div class="rgt">
      <div class="amount">₡{{ props.item.amount }}</div>
      <div class="status">
        <span class="dotted"></span>{{ $t('order.statusValid') }}
      </div>
    </div>
    <van-icon name="arrow" class="arrow" />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const props = defineProps({
  item: { type: Object, default: () => ({}) },
});
const goDetailsHandler = () => {
  router.push(`/orderDetail/${props.item.id}`);
};
</script>

<style lang="scss" scoped>
.order-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  &:active {
    background: #f9fafb;
  }
  .lft {
    flex: 1;
    .lottery {
      font-size: 30px;
      font-weight: 600;
      color: var(--text-primary);
      margin-bottom: 8px;
    }
    .meta {
      display: flex;
      align-items: center;
      color: var(--text-muted);
      font-size: 22px;
      .sn {
        color: var(--brand-primary);
        font-weight: 500;
      }
      .dot {
        margin: 0 8px;
      }
    }
  }
  .rgt {
    text-align: right;
    margin-right: 16px;
    .amount {
      font-size: 34px;
      font-weight: 700;
      color: var(--brand-secondary);
      margin-bottom: 6px;
    }
    .status {
      display: inline-flex;
      align-items: center;
      color: #10b981;
      font-size: 20px;
      background: #d1fae5;
      padding: 4px 12px;
      border-radius: 999px;
      .dotted {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #10b981;
        margin-right: 6px;
      }
    }
  }
  .arrow {
    font-size: 32px;
    color: var(--text-muted);
  }
}
</style>
